import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { MainSmsIntegrationTypeEnum } from '@zaoblako/shared/modules/integration/enums/main.sms.integration.type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link MainSmsIntegrationTypeEnum} enumeration values */
export const MainSmsIntegrationTypeEnumI18n: EnumI18nInterface<MainSmsIntegrationTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [MainSmsIntegrationTypeEnum.EMAIL]: 'Электронная почта',
    [MainSmsIntegrationTypeEnum.SMS]: 'SMS-сообщение',
  },
  [I18nLocalesEnum.EN_US]: {
    [MainSmsIntegrationTypeEnum.EMAIL]: 'E-Mail',
    [MainSmsIntegrationTypeEnum.SMS]: 'SMS-message',
  },
};
